import script from "./CommentList.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentList.vue?vue&type=script&setup=true&lang=js"

import "./CommentList.vue?vue&type=style&index=0&id=23c3912c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c3912c"]])

export default __exports__